<script lang="ts" setup></script>
<template>
  <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M21.875 15.625V19.7917C21.875 20.3442 21.6555 20.8741 21.2648 21.2648C20.8741 21.6555 20.3442 21.875 19.7917 21.875H5.20833C4.6558 21.875 4.12589 21.6555 3.73519 21.2648C3.34449 20.8741 3.125 20.3442 3.125 19.7917V15.625"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="square"
      stroke-linejoin="round"
    />
    <path
      d="M17.7084 8.33333L12.5001 3.125L7.29175 8.33333"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="square"
      stroke-linejoin="round"
    />
    <path
      d="M13.5 3.125C13.5 2.57272 13.0523 2.125 12.5 2.125C11.9477 2.125 11.5 2.57272 11.5 3.125H13.5ZM11.5 15.625V16.625H13.5V15.625H11.5ZM11.5 3.125V15.625H13.5V3.125H11.5Z"
      fill="currentColor"
    />
  </svg>
</template>
